import { PureComponent, ReactNode } from 'react';
import { BedFilledIcon } from '../common/Icons';
import { Patient } from '../../store/types/patient';
import { AnimatePresence } from 'framer-motion';
import AdmitPatientDrawer from './AdmitPatientDrawer';
import { getMActiveId } from '../../store/localstorage';
import { MISC_KEYS, getItemFromMisc } from '../../store/idbHandler';
import { Ipd } from '../../api/fetchMyGenie';

interface Props {
    patient: Patient;
}

interface State {
    isIpdEnabled: boolean;
    isAdmitPatientModalVisible: boolean;
}

class AdmitPatientAddPtButton extends PureComponent<Props, State> {
    state: State = {
        isIpdEnabled: false,
        isAdmitPatientModalVisible: false,
    };

    bedFilledIcon = BedFilledIcon('w-24 h-24 fill-actionPrimary transform scale-125');

    componentDidMount(): void {
        const myId = getMActiveId();
        if (!myId) {
            return;
        }
        getItemFromMisc<Ipd>(myId, MISC_KEYS.ipd)
            .then((i) => {
                this.setState({ isIpdEnabled: i?.enabled });
            })
            .catch(console.error);
    }

    toggleAdmitPatientModalVisible = () => {
        const { isAdmitPatientModalVisible } = this.state;
        this.setState({ isAdmitPatientModalVisible: !isAdmitPatientModalVisible });
    };

    render(): ReactNode {
        const { patient } = this.props;
        const { isIpdEnabled, isAdmitPatientModalVisible } = this.state;
        const { bedFilledIcon, toggleAdmitPatientModalVisible } = this;

        if (!isIpdEnabled) {
            return null;
        }

        return (
            <div
                onClick={toggleAdmitPatientModalVisible}
                className="flex flex-col items-center justify-center space-y-24 border border-transparent cursor-pointer rounded-8 w-144 h-144 hover:border-actionPrimary bg-status-infoBG"
            >
                <div className="flex items-center justify-center w-64 h-64 rounded-full bg-white">
                    <div className="flex items-center w-20 h-20 justify-center">
                        {bedFilledIcon}
                    </div>
                </div>
                <p className="text-actionPrimary font-700 text-14">Admit Patient</p>

                <AnimatePresence>
                    {isAdmitPatientModalVisible && (
                        <AdmitPatientDrawer
                            closeMe={toggleAdmitPatientModalVisible}
                            patient={patient}
                        />
                    )}
                </AnimatePresence>
            </div>
        );
    }
}

export default AdmitPatientAddPtButton;
